

























































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import DraggableIcon from './DraggableIcon.vue';
import { GroupLevelAttributeValue } from '@/jbi-shared/types/jaas-group-level-attributes.types';
import AttributeActionButtons from './AttributeActionButtons.vue';

@Component({
  components: {
    DraggableIcon,
    AttributeActionButtons
  }
})
export default class GroupLevelAttributeBooleanField extends Vue {
  @Prop() attributeValue!: GroupLevelAttributeValue;
  @Prop() fieldClasses!: any;
  @Prop() duplicationError!: boolean;
  @Prop({ default: false }) isSettings!: boolean;
  @Prop({ default: false }) overrideDisableDraggable!: boolean;
  @Prop({ default: false }) overrideDisableAttributeButton!: boolean;
  @Prop() deleteAttribute!: () => void;
  @Prop() updateAttributeValue!: (attribute: GroupLevelAttributeValue) => void;
  @Prop() toggleAttributeRequire!: (
    attribute: GroupLevelAttributeValue
  ) => void;
  @Prop() editAttribute!: (attribute: GroupLevelAttributeValue) => void;

  fieldErrorMsg: string = '';

  // Computed property so changes from the value from parent component are synced
  get isRequired() {
    return this.attributeValue.groupLevelAttributeSpec.isRequired;
  }

  // Only update error state
  @Watch('isRequired', { immediate: true })
  updateErrorState() {
    if (this.attributeValue.value) {
      this.validateRequiredFieldValues();
      return;
    }
    this.attributeValue.hasFieldError = this.isRequired;
    this.updateAttributeValue(this.attributeValue);
  }

  @Watch('attributeValue.value')
  validateRequiredFieldValues() {
    // validate null / empty values for required fields
    if (this.isRequired && this.attributeValue.value === null) {
      this.fieldErrorMsg = `Please select a value for ${this.attributeValue.label}.`;
      this.attributeValue.hasFieldError = true;
      this.updateAttributeValue(this.attributeValue);
      return;
    }

    this.fieldErrorMsg = '';
    this.attributeValue.hasFieldError = false;
    this.updateAttributeValue(this.attributeValue);
  }
}
